import { Controller } from "@hotwired/stimulus";

// Tracks the Flex orientation interstitial — the screen briefs as
// "[shipped soon]". Wire by adding data-controller="flex-interstitial"
// to the interstitial root element. When the interstitial doesn't exist
// yet, this controller simply is never instantiated.
//
// Properties source_report_id / source_influencer_name should be passed
// in via data values so the events match flex_account_created shape.
export default class extends Controller {
  static values = {
    sourceReportId: String,
    sourceInfluencerName: String,
  };

  connect() {
    this.capture("flex_interstitial_shown");
  }

  ctaClicked() {
    this.capture("flex_interstitial_cta_clicked");
  }

  capture(eventName) {
    if (typeof window.posthog === "undefined") return;
    window.posthog.capture(eventName, {
      source_report_id: this.sourceReportIdValue || null,
      source_influencer_name: this.sourceInfluencerNameValue || null,
    });
  }
}
